import React, { useEffect, useState } from 'react';
import strings from '../../strings/strings.json'
import DiskRowHandler from './disk_row_handler';
import { useHistory } from 'react-router-dom';
import { driveInfo, mount, unmount } from 'api/api_service';
import { IDriveInfo } from 'types';
import { Modal, Box, CircularProgress } from '@mui/material';
import DriveInfoDetails from './drive_info_details';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import Layout from 'components/layout';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: '0 1px 60px 0 rgba(155, 181, 190, 0.2)',
    borderRadius: '14px',
    p: 4,
};
export default function DiskStatus() {

    const dispatch = useDispatch();
    const history = useHistory()
    const [data, setData] = useState<IDriveInfo[]>([])
    const [selectedDiskID, setSelectedDiskId] = useState<string>()
    const [driveInfoDataClicked, setDriveInfoDataClicked] = useState<IDriveInfo>()
    const [inputOnchangePassword, setInputOnchagePassword] = useState('')
    const [opeModal, setOpenModal] = useState(false)
    const [modalIsLoading, setModalIsLoading] = useState(false)

    useEffect(() => {
        getDriveInfo()
    }, [])

    const getDriveInfo = () => {
        driveInfo()
            .then(res => {
                if (res.status === 200) {
                    setData(res.data.data)
                }
            })
    }

    const handleCloseModal = () => setOpenModal(false);
    const diskRowClickedHandler = (data: IDriveInfo) => {
        setSelectedDiskId(data.device)
        setDriveInfoDataClicked(data)
    }

    const mountDriveHandler = (data: IDriveInfo) => {

        setDriveInfoDataClicked(data)
        if (data.is_mounted) {
            unmount({
                "device": data.device,
            }).then(res => {
                if (res.status == 200 && res.data.success) {
                    getDriveInfo()
                    dispatch(showSnackbar({ "open": true, severity: "success", msg: `${strings.public_operationDone}` }));
                } else {
                    dispatch(showSnackbar({ "open": true, severity: "error", msg: `${strings.public_unmountFailed}` }));
                }
            })
        } else {
            if (data.is_bitlocked)
                setOpenModal(true)
            else
                mount({
                    "device": data.device
                }).then(res => {
                    if (res.status == 200 && res.data.success) {
                        getDriveInfo()
                    } else {
                        dispatch(showSnackbar({ "open": true, severity: "error", msg: `${strings.public_mountFailed}` }));
                    }
                })
        }
    }

    const continueHandler = () => {
        if (data.some(x => x.is_mounted)) // agar hich yek az drive ha entekhab nashavand edame nadarim
            history.push('/chooseFile')
        else
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.disk_selectOneDiskAtleast}` }));

    }

    const modalConfirmHandler = () => {
        if (inputOnchangePassword && driveInfoDataClicked !== undefined) {
            setModalIsLoading(true)
            mount({
                "device": driveInfoDataClicked.device,
                "password": inputOnchangePassword
            }).then(res => {
                if (res.status == 200 && res.data.success) {
                    getDriveInfo()
                    setModalIsLoading(false)
                    setOpenModal(false)
                }
                else {
                    dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.public_wrongPassword}` }));
                    setModalIsLoading(false)
                }
            })
        } else {
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: `${strings.public_invalidPassword}` }));
        }
    }

    const diskMapper = (data: object, index: any) => {
        return (
            <React.Fragment key={index}>
                <DiskRowHandler
                    data={data}
                    diskRowClicked={(data) => diskRowClickedHandler(data)}
                    diskId={selectedDiskID}
                    mountButtonClicked={(data) => mountDriveHandler(data)}
                />
            </React.Fragment>
        )
    }

    return (
        <Layout>
            <div className='w-full px-10'>
                <div className='flex h-full flex-col w-full'>
                    <div className='flex h-14 items-center justify-start'><span className='primary_text_color font-bold text-lg'>{strings.disk_title}</span></div>
                    <div className='flex-1 grid grid-cols-3 w-full mt-10 border-b border-b-gray-200 pb-10 '>
                        <div className={` ${driveInfoDataClicked !== undefined ? 'border-l border-gray-200 col-span-2' : 'col-span-3'}`}>
                            <span className='primary_text_color font-bold text-base'>{strings.disk_status}</span>
                            <div dir='ltr' className={`mt-5 overflow-auto`}>
                                {
                                    data.length !== 0 &&
                                    data.map(diskMapper)
                                }
                            </div>
                        </div>
                        {
                            driveInfoDataClicked !== undefined &&
                            <div className='col-span-1'>
                                <DriveInfoDetails
                                    data={driveInfoDataClicked}
                                />
                            </div>
                        }
                    </div>
                    <div className='flex h-20 py-5 justify-between'>
                        <button className='rounded-full border border-black px-10 py-3' onClick={() => history.goBack()}>{strings.public_back}</button>
                        <button className='text-white rounded-full px-10 py-3 primary_bg_color' onClick={() => continueHandler()}>{strings.public_continue}</button>
                    </div>
                    <Modal
                        open={opeModal}
                        onClose={handleCloseModal}>
                        <Box sx={style}>
                            <div className='flex justify-center flex-col items-center'>
                                <span className='primary_text_color font-bold'>{strings.public_password}</span>
                                <span className='secondry_text_color text-sm'>{strings.disk_enterPassSubtitle}</span>
                                <input type="password" className='border border-gray-200 text-right mt-5 py-1 px-1 rounded-lg' placeholder={strings.public_password} onChange={(e) => setInputOnchagePassword(e.target.value)} />
                                <div className='flex justify-between pt-5 px-6 mt-5 border-t border-t-gray-100 w-full'>
                                    <button className='text-white w-28 rounded-full px-8 py-2 primary_bg_color text-xs' onClick={() => !modalIsLoading && modalConfirmHandler()}>
                                        {
                                            modalIsLoading ?
                                                <CircularProgress color="inherit" size={15} />
                                                :
                                                strings.public_confirm
                                        }
                                    </button>
                                    <button className='rounded-full w-28 border border-black px-8 py-2 text-xs' onClick={() => handleCloseModal()}> {strings.public_cancel}</button>
                                </div>
                            </div>
                        </Box>
                    </Modal>
                </div>
            </div>
        </Layout>
    )
}
